import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { TitleThickThin } from "@components/titles";
import { useTranslations } from "next-intl";

const logos = [
  { src: "banco_popular_logo.svg", alt: "Logo Banco Popular" },
  { src: "banco_reservas_logo.svg", alt: "Logo Banco Reservas" },
  { src: "banco_bhd_logo.svg", alt: "Logo Banco BHD" },
  { src: "scotiabank_logo.svg", alt: "Logo ScotiaBank" },
];

function HeroSection() {
  const translation = useTranslations("mortgageCalculator");
  const translationCalculator = useTranslations(
    "mortgageCalculator.calculator"
  );

  const title = translation("title") || "";

  const [first, ...rest] = title.split(" ");

  return (
    <Wrapper>
      <ImageWrapper />
      <Content>
        <ContentLogos>
          {logos.map((item) => (
            <BankLogos
              src={`/icons/${item.src}`}
              alt={item.alt}
              key={item.src}
            />
          ))}
        </ContentLogos>
        <ContentDetails>
          <TitleThickThin
            component="h1"
            thickTitle={first}
            thinTitle={rest.join(" ")}
            color="--color-brand-bg-secondary"
            align="left"
            mb="30px"
          ></TitleThickThin>
          <p>{translationCalculator("instruction")}</p>
          <p>{translationCalculator("description")}</p>
        </ContentDetails>
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  height: 976px;
  position: relative;
  margin-bottom: -200px;

  @media screen and (max-width: 991px) {
    height: auto;
  }

  @media screen and (max-width: 570px) {
    margin-bottom: 0;
  }
`;

const ImageWrapper = styled.div`
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  background-image: url("/images/image-optimize/calculadora_de_prestamos_background.webp");

  @media screen and (max-width: 991px) {
    height: 60vw;
    background-position: top center;
  }
`;

const Content = styled.div`
  position: absolute;
  left: 105px;
  bottom: 0;
  width: 501px;

  @media screen and (max-width: 991px) {
    position: static;
    width: 100%;
  }
`;

const ContentLogos = styled.div`
  background-color: var(--color-brand-bg-secondary);
  border-radius: 100px;
  width: 100%;
  height: 86px;
  max-width: 448px;
  margin: 0 auto 100px;
  padding: 0 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  @media screen and (max-width: 991px) {
    max-width: none;
    border-radius: 0;
    margin-bottom: 0;
    justify-content: center;
  }
`;

const ContentDetails = styled.div`
  background-color: var(--color-brand-blue-main);
  height: 580px;
  padding: 70px 39px 39px;

  & > p {
    color: var(--color-brand-bg-secondary);
    font-size: 0.938rem;
    font-weight: 400;
    margin-bottom: 20px;
    line-height: 18px;
  }

  @media screen and (max-width: 570px) {
    height: auto;
  }

  @media screen and (max-width: 991px) {
    & > * {
      max-width: 720px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media screen and (max-width: 767px) {
    & > * {
      max-width: 540px;
    }
  }
`;

const BankLogos = styled.img`
  @media screen and (max-width: 991px) {
    margin: 0 12px;
  }
`;

export default HeroSection;
